import { filter, get } from "lodash";
import { searchEntities } from "../../store/selectors/search";

export const selectProperties = (state) =>
  searchEntities(state, "properties", [
    "name",
    "addressLine1",
    "addressLine2",
    "city",
    "province",
    "propertyManager.firstname",
    "propertyManager.lastname",
    "propertyManager.email",
  ]);

export const selectPropertyById = (state, id) =>
  selectProperties(state).find((p) => p.id === id);

export const selectPropertyNotes = (state, id) =>
  get(selectPropertyById(state, id), ["notes"], []);

export const selectPropertyDocuments = (state, id) =>
  get(selectPropertyById(state, id), ["documents"], []);

export const selectPropertyServiceRequests = (state, id) =>
  get(selectPropertyById(state, id), ["serviceRequests"], []);
